import { render, staticRenderFns } from "./UserPhone.vue?vue&type=template&id=3a321f88&scoped=true"
import script from "./UserPhone.vue?vue&type=script&lang=ts"
export * from "./UserPhone.vue?vue&type=script&lang=ts"
import style0 from "./UserPhone.vue?vue&type=style&index=0&id=3a321f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a321f88",
  null
  
)

export default component.exports